import { API } from "@/lib/api";

// Fire-and-forget demo funnel analytics. Uses plain fetch (keepalive) so it bypasses
// the demo-mode axios interceptor that blocks mutations, and never breaks the UI.
export function track(event, product = "", meta = {}) {
  try {
    fetch(`${API}/demo/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, product, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* noop */ }
}
